import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import MenuIcon from "@mui/icons-material/Menu";
import UserprofileSidebar from "../pages/UserprofileSidebar";

function ProfileLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Container fluid className="p-0">
      {/* Mobile Header */}
      <div
        className="d-md-none"
        style={{
          padding: "12px 16px",
          background: "#0f172a",
          color: "#fff",
        }}
      >
        <Button
          color="light"
          size="sm"
          onClick={() => setSidebarOpen(true)}
        >
          <MenuIcon />
        </Button>
      </div>

      <Row className="g-0">
        {/* Desktop Sidebar */}
        <Col md="3" lg="2" className="d-none d-md-block">
          <UserprofileSidebar />
        </Col>

        {/* Content */}
        <Col xs="12" md="9" lg="10">
          <div style={{ padding: 20 }}>
            <Outlet />
          </div>
        </Col>
      </Row>

      {/* Mobile Sidebar */}
      <Offcanvas
        isOpen={sidebarOpen}
        toggle={() => setSidebarOpen(false)}
      >
        <OffcanvasHeader toggle={() => setSidebarOpen(false)}>
          
        </OffcanvasHeader>

        <OffcanvasBody className="p-0">
          <UserprofileSidebar />
        </OffcanvasBody>
      </Offcanvas>
    </Container>
  );
}

export default ProfileLayout;